// Permisos del motor de comisiones que piden las pantallas (`CommissionPermissionConstants` del motor).
export const COMMISSION_PERMISSIONS = {
    planRead: 'retail.commission.plan.read',
    planWrite: 'retail.commission.plan.write',
    planPublish: 'retail.commission.plan.publish',
    payoutRead: 'retail.commission.payout.read',
    adjustmentWrite: 'retail.commission.adjustment.write',
    paymentRead: 'retail.commission.payment.read',
    paymentManage: 'retail.commission.payment.manage',
    statementRead: 'retail.commission.statement.read',
} as const;
